const state = {
  sidebarOpen: false
}

const mutations = {
  SET_SIDEBAR_OPEN(state, value) {
    state.sidebarOpen = value
  }
}

const actions = {
  openSidebar({ commit }) {
    commit('SET_SIDEBAR_OPEN', true)
  },
  closeSidebar({ commit }) {
    commit('SET_SIDEBAR_OPEN', false)
  },
  toggleSidebar({ commit, state }) {
    commit('SET_SIDEBAR_OPEN', !state.sidebarOpen)
  }
}

const getters = {
  isSidebarOpen: state => state.sidebarOpen
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
